/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Bodlabel2Inputs */

const ja_company_companydetails_bodlabel2 = /** @type {(inputs: Company_Companydetails_Bodlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取締役会`)
};

const en_company_companydetails_bodlabel2 = /** @type {(inputs: Company_Companydetails_Bodlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board of Directors`)
};

/**
* | output |
* | --- |
* | "Board of Directors" |
*
* @param {Company_Companydetails_Bodlabel2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_bodlabel2 = /** @type {((inputs?: Company_Companydetails_Bodlabel2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Bodlabel2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_bodlabel2(inputs)
	return en_company_companydetails_bodlabel2(inputs)
});
export { company_companydetails_bodlabel2 as "company_companyDetails_bodLabel" }